module.exports = __webpack_public_path__ + "img/asset-active-v2.ee7b376c.svg";